import React from 'react';

import classes from 'components/common/Avatar/Avatar.module.scss';
import { getAvatarColor, getInitials } from 'components/common/Avatar/Avatar.utils';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

interface IAvatarProps {
    fullName: string;
    isUnassigned?: boolean;
    className: string;
}

export const Avatar = ({ fullName, isUnassigned = false, className = '' }: IAvatarProps) => (
    <span
        className={`${classes.avatar} ${isUnassigned ? classes.unAssigned : classes[getAvatarColor(fullName.trim())]} ${className}`}
        data-testid={'avatar'}
    >
        {isUnassigned ? (
            <MuiIcon icon={'person'} fontSize={'2.4rem'} color={'inherit'} />
        ) : (
            getInitials(fullName.trim())
        )}
    </span>
);
